import React, { useEffect } from 'react';
import HeaderItem from '../HeaderItem';
import { useAppStore } from '../../../context/AppContext';
import { SidePanelModulEnum } from '../../../enums/sidePanelModulEnum';
import { useConnectionStore } from 'src/context/ConnectionContext';

const AppsMenuComponent: React.FC = () => {
    const { appsMenu, setAppsMenu, setVisibleSidePanelModuleIndex } = useAppStore();
    const { isOffline } = useConnectionStore();

    const applyScriptToPage = (src) => {
        let script = document.querySelector(`script[src="${src}"]`);
        if (!script) {
            script = document.createElement('script');
            script.innerHTML = src;
            document.body.appendChild(script);
        }
    };

    useEffect(() => {
        if (appsMenu) {
            applyScriptToPage(appsMenu.script);
            setAppsMenu(appsMenu);
        }
    }, [appsMenu]);

    const itemClicked = () => () => {
        setVisibleSidePanelModuleIndex(SidePanelModulEnum.AppsMenu);
    };

    if (isOffline) return <></>;

    return <HeaderItem title={'My apps'} iconName={'th'} path={''} onItemClick={itemClicked()} />;
};

export default AppsMenuComponent;
